import { Box, Button, Stack, Typography } from '@mui/material';
import { ErrorSvg, PlusIcon } from '@schooly/style';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export const PayableFeesEmptyStub: FC = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <Typography variant="h1" textAlign="center" mb={1} maxWidth={417}>
        <FormattedMessage id="students-Empty-title" />
      </Typography>

      <Typography variant="h3" mb={3}>
        <FormattedMessage id="students-Empty-subtitle" />
      </Typography>

      <Link to="/applications">
        <Button startIcon={<PlusIcon />}>
          <FormattedMessage id="applications-New" />
        </Button>
      </Link>
    </Stack>
  );
};

export interface PayableFeesErrorStubProps {
  textId: string;
  subTextId: string;
}

export const PayableFeesErrorStub: FC<PayableFeesErrorStubProps> = ({ textId, subTextId }) => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <Box sx={{ mb: 5, '& svg': { width: 300, height: 300 } }}>
        <ErrorSvg />
      </Box>

      <Typography variant="h1" textAlign="center" mb={1} maxWidth={700}>
        <FormattedMessage id={textId} />
      </Typography>

      <Typography variant="h3" color="text.primary">
        <FormattedMessage id={subTextId} />
      </Typography>
    </Stack>
  );
};
